import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Svg } from "../svg/Svg";
export const ListIcon = React.forwardRef((props, ref) => (_jsx(Svg, { "data-testid": "ListIcon", ...props, ref: ref, children: _jsx("path", { fill: "currentColor", d: "M0 1h16v2H0V1zm0 4h16v2H0V5zm0 4h16v2H0V9zm0 4h16v2H0v-2z" }) })));
ListIcon.displayName = "ListIcon";
